export default "__VITE_ASSET__Dls4sYAP__"